import React, { forwardRef } from 'react'
import { Link as InertiaLink } from '@inertiajs/react'
import classNames from 'classnames'

export const Link = forwardRef(({ href, url, activeClass, method, children, className, data, onClick, ...props }, ref) => {
  const linkClass = classNames(className, {
    [activeClass || 'active']: url && url.current === (href.replace(/^\/|\/$/g, '') || '/')
  })

  let queryParams = ''

  if ((!method || method.toLowerCase() === 'get') && !!data) {
    queryParams = `?${Object.keys(data).map(d => `${d}=${data[d]}`).join('&')}`
  }

  return (
    <InertiaLink
      href={`${href}${queryParams}`}
      className={linkClass}
      method={method || 'get'}
      data={queryParams ? null : data}
      onClick={onClick}
      {...props}
    >{children}
    </InertiaLink>
  )
})
